export default __webpack_public_path__ + "59ab7e71317ccec8086556c4a44a4445.png";